import { format } from 'date-fns';

class HolidaysService {
  async getHolidays(year) {
    try {
      const response = await fetch(`https://calendrier.api.gouv.fr/jours-feries/metropole/${year}.json`);
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des jours fériés');
      }
      const data = await response.json();
      
      // Convertir les données en format plus pratique
      return Object.entries(data).map(([date, name]) => ({
        date: new Date(date),
        name
      }));
    } catch (error) {
      console.error('Erreur lors de la récupération des jours fériés:', error);
      return [];
    }
  }

  // Vérifie si une date donnée est un jour férié
  isHoliday(date, holidays) {
    const formattedDate = format(date, 'yyyy-MM-dd');
    return holidays.some(holiday => 
      format(holiday.date, 'yyyy-MM-dd') === formattedDate
    );
  }

  // Récupère le nom du jour férié si c'en est un
  getHolidayName(date, holidays) {
    const formattedDate = format(date, 'yyyy-MM-dd');
    const holiday = holidays.find(h => 
      format(h.date, 'yyyy-MM-dd') === formattedDate
    );
    return holiday ? holiday.name : null;
  }
}

export const holidaysService = new HolidaysService();

// Service pour calculer les jours fériés français
export const getHolidaysForYear = async (year) => {
  try {
    const response = await fetch(`https://calendrier.api.gouv.fr/jours-feries/metropole/${year}.json`);
    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des jours fériés');
    }
    const holidays = await response.json();
    return Object.keys(holidays).map(date => new Date(date));
  } catch (error) {
    console.warn('Impossible de récupérer les jours fériés:', error);
    // Fallback avec les jours fériés fixes
    return getFallbackHolidays(year);
  }
};

const getFallbackHolidays = (year) => {
  const holidays = [];
  
  // Jours fériés fixes
  holidays.push(new Date(year, 0, 1));   // Nouvel An
  holidays.push(new Date(year, 4, 1));   // Fête du Travail
  holidays.push(new Date(year, 4, 8));   // Victoire 1945
  holidays.push(new Date(year, 6, 14));  // Fête Nationale
  holidays.push(new Date(year, 7, 15));  // Assomption
  holidays.push(new Date(year, 10, 1));  // Toussaint
  holidays.push(new Date(year, 10, 11)); // Armistice
  holidays.push(new Date(year, 11, 25)); // Noël
  
  // Calcul de Pâques (algorithme de Gauss)
  const easter = calculateEaster(year);
  holidays.push(easter); // Pâques
  holidays.push(new Date(easter.getTime() + 24 * 60 * 60 * 1000)); // Lundi de Pâques
  holidays.push(new Date(easter.getTime() + 39 * 24 * 60 * 60 * 1000)); // Ascension
  holidays.push(new Date(easter.getTime() + 50 * 24 * 60 * 60 * 1000)); // Lundi de Pentecôte
  
  return holidays;
};

const calculateEaster = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  
  return new Date(year, month - 1, day);
};

export const isHoliday = (date, holidays) => {
  return holidays.some(holiday => 
    holiday.getFullYear() === date.getFullYear() &&
    holiday.getMonth() === date.getMonth() &&
    holiday.getDate() === date.getDate()
  );
};

export const hasHolidayInPeriod = (startDate, endDate, holidays) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    if (isHoliday(d, holidays)) {
      return true;
    }
  }
  return false;
}; 